import { render, staticRenderFns } from "./controleDialog.vue?vue&type=template&id=d894a3b0&"
import script from "./controleDialog.vue?vue&type=script&lang=js&"
export * from "./controleDialog.vue?vue&type=script&lang=js&"
import style0 from "./controleDialog.vue?vue&type=style&index=0&id=d894a3b0&prod&lang=scss&"
import style1 from "./controleDialog.vue?vue&type=style&index=1&id=d894a3b0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports